import { render, staticRenderFns } from "./cbos.vue?vue&type=template&id=4795fc0c"
import script from "./cbos.vue?vue&type=script&lang=js"
export * from "./cbos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports